import {client} from '../axios';
import {ResponseError} from "@/types";
import {resolveError} from "@/data/_resolveError";

export const dismissNotification = (
    notificationKey: string,
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post('/user/notifications/dismiss', {
        notification_key: notificationKey
    })
    .then(() => {
        success();
    })
    .catch((error) => resolveError(error, failed));
}

export const markNotificationAsShown = (
    notificationKey: string,
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post('/user/notifications/mark-shown', {
        notification_key: notificationKey
    })
    .then(() => {
        success();
    })
    .catch((error) => resolveError(error, failed));
}
